import { request } from '@/common/utils/request'

export function getDiagnosisDetail(params) {
  return request
    .get({
      url: 'feidian.bdapp.diagnosis.getDetail',
      params,
    })
    .then(res => res.data)
}

/** 经营概览「实时」周期专用；需传 tab: 'overview' 等与后端约定字段 */
export function getDiagnosisOverviewRealtime(params) {
  return request
    .get({
      url: 'feidian.bdapp.diagnosis.getRealtimeDetail',
      params,
      timeout: 13 * 1000,
    })
    .then(res => res.data)
}

export function getDiagnosisInit() {
  return request
    .get({
      url: 'feidian.bdapp.diagnosis.init',
    })
    .then(res => res.data)
}
